export function coop(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 4;
  e.currentTarget.maxLength = 4;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function agencia(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 4;
  e.currentTarget.maxLength = 4;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function beneficiario(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 5;
  e.currentTarget.maxLength = 5;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function posto(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 2;
  e.currentTarget.maxLength = 2;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function data(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 10;
  e.currentTarget.maxLength = 10;
  let value = e.currentTarget.value;
  if (!value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)) {
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d)/, '$1/$2');
    value = value.replace(/(\d{2})(\d)/, '$1/$2');
    value = value.replace(/(\d{4})(\d)/, '$1');
    e.currentTarget.value = value;
  }
  return e;
}
export function identificadorParceiro(e: React.FormEvent<HTMLInputElement>) {
  e.currentTarget.minLength = 20;
  e.currentTarget.maxLength = 20;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function conta(e: React.FormEvent<HTMLInputElement>) {
  // let value = e.currentTarget.value;
  // // if (!value.match(/^(\d{1,6})\/(\d{7})$/)) {
  // //   value = value.replace(/\D/g, '');
  // //   value = value.replace(/(\d{6})(\d)/, '$1-$2');
  // //   value = value.replace(/(\d{7})(\d)/, '$1');
  // //   e.currentTarget.value = value;
  // // }
  // return value;
  e.currentTarget.maxLength = 7;
  let value = e.currentTarget.value;
  value = value.replace(/\D/g, '');
  e.currentTarget.value = value;
  return e;
}

export function textAndNumberOnly(e: React.FormEvent<HTMLInputElement>) {
  let value = e.currentTarget.value;
  value = value.replace(/([a-zA-Z0-9])/, '');
  e.currentTarget.value = value;
  return e;
}
